import {
  UPDATE_FEEDS_RELEVANT_BEGIN,
  UPDATE_FEEDS_RELEVANT_SUCCESS,
  UPDATE_FEEDS_RELEVANT_FAILURE,
  DAY_UNIT,
  NEGATIVE, 
  NEUTRAL, 
  POSITIVE, 
  JOY, 
  ANGER, 
  FEAR, 
  SADNESS, 
  TOTAL, 
  CATEGORY_KEY,
  ALL
} from './constants';
import { getQueryUnit } from '../../shared-components/chart/redux/chartsService';
import http from '../../../common/http';
import { apiEndPoints, IS_SARCASM_ENABLED } from '../../../common/globalConstants';

const POST_COUNTS_KEY = "postCounts";
const SARCASTIC_KEY   = "sarcastic";
const TREND_CHART_COUNT_CHANGES_KEY = "trendChartCountChanges";
const NON_DATE_TIME_SPECIFIC_CHART_COUNT_CHANGES_KEY = "nonDateTimeSpecificChartCountsChanges";
const SUB_TOPIC_CHART_COUNT_CHANGES_KEY = "subTopicChartCountChanges";
const FEED_MODAL_TAB_COUNTS = "feedModalTabCounts"; 

export function updateFeedsRelevant(props = {}) {
  return dispatch => {
    dispatch({
      type: UPDATE_FEEDS_RELEVANT_BEGIN,
    });
    const {
      feedId,
      relevance,
      dashboardFilterDate,
      feedModalMinimumSarcasmScore,
      feedModalMaximumSarcasmScore
    } = props;
    const trendChartTimeUnit = dashboardFilterDate ? getQueryUnit(dashboardFilterDate) : DAY_UNIT
    const toDate = dashboardFilterDate ? dashboardFilterDate.toDate : '';
    const url = `${apiEndPoints.feeds.UPDATE_FEED_RELEVANT}?feedId=${feedId}&relevance=${relevance}&toDate=${
                  toDate}&trendChartTimeUnit=${trendChartTimeUnit}&feedModalMinSarcasmScore=${
                  feedModalMinimumSarcasmScore}&feedModalMaxSarcasmScore=${feedModalMaximumSarcasmScore}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.patch(url);
      doRequest.then(
        res => {
          let mergedPropsAndResponse = Object.assign({}, props, res.data);
          dispatch({
            type: UPDATE_FEEDS_RELEVANT_SUCCESS,
            data: mergedPropsAndResponse,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: UPDATE_FEEDS_RELEVANT_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_FEEDS_RELEVANT_BEGIN:
      return {
        ...state,
        updateFeedsRelevantBegin: true,
        updateFeedsRelevantSuccess: false,
        updateFeedsRelevantFailure: false,
        updateCommentsRelevantSuccess: false,
        updateCommentsRelevantFailure: false,
        updateTweetsRelevantSuccess: false,
        updateTweetsRelevantFailure: false,
        updateUploadedCommentsRelevantSuccess: false,
        updateUploadedCommentsRelevantFailure: false,
        postAfterRelevanceUpdates: null
      };
    case UPDATE_FEEDS_RELEVANT_SUCCESS: {
      const nonDateTimeSpecificChartCountsChanges = action.data.data[NON_DATE_TIME_SPECIFIC_CHART_COUNT_CHANGES_KEY];
      const trendChartCountChanges = action.data.data[TREND_CHART_COUNT_CHANGES_KEY];
      const subTopicChartCountChanges = action.data.data[SUB_TOPIC_CHART_COUNT_CHANGES_KEY];
      const updatedFeeds = state.allFeeds.data.map(feed => {
        if (feed.feedId === String(action.data.feedId)) {
          feed.relevance = action.data.relevance;
          state.postAfterRelevanceUpdates = feed;
          state.postAfterRelevanceUpdates[NON_DATE_TIME_SPECIFIC_CHART_COUNT_CHANGES_KEY] = nonDateTimeSpecificChartCountsChanges;
          state.postAfterRelevanceUpdates[TREND_CHART_COUNT_CHANGES_KEY] = trendChartCountChanges;
          state.postAfterRelevanceUpdates[SUB_TOPIC_CHART_COUNT_CHANGES_KEY] = subTopicChartCountChanges;
        }
        if (action.data.relevance === true && feed.feedId === String(action.data.feedId)) {
          feed = updatePostCounts(
            feed,
            action.data.data[POST_COUNTS_KEY]
          );
        }
        return feed;
      });
      state.allFeeds.data = updatedFeeds;

      const updatedComments = state.allComments.data.map(comment => {
        if (comment.postId === String(action.data.postId)) {
          const postRelevanceAfterToggled = action.data.relevance;
          comment = updateCommentRelevanceAndRelevanceButton(
            comment,
            postRelevanceAfterToggled
          );
        }
        return comment;
      });
      state.allComments.data = updatedComments;

      if (state.feedDetails.data) {
        const updatedCommentsInFeedModal = updateCommentsInFeedModal(
          state.feedDetails.data,
          action.data
        );
        state.feedDetails.data = updatedCommentsInFeedModal;
      }

      if (action.data.relevance === true) {
        const updatedFeedModalFilteredCommentCounts = updateFeedModalFilteredCommentCounts(
          state.feedDetails.filteredCommentCounts,
          action.data.data[FEED_MODAL_TAB_COUNTS]
        );
        state.feedDetails.filteredCommentCounts = updatedFeedModalFilteredCommentCounts;
      }
      
      return {
        ...state,
        updateFeedsRelevantBegin: false,
        updateFeedsRelevantSuccess: true,
      };
    }
    case UPDATE_FEEDS_RELEVANT_FAILURE: {
      return {
        ...state,
        updateFeedsRelevantBegin: false,
        updateFeedsRelevantFailure: true,
      };
    }
    default: {
      return state;
    }
  }
}

export function updateCommentsInFeedModal(
  feedDetails,
  actionData
){
  const updatedCommentsInFeedModal = feedDetails.map(comment => {
    if (comment.postId === String(actionData.postId)) {
      const postRelevanceAfterToggled = actionData.relevance;
      comment = updateCommentRelevanceAndRelevanceButton(
        comment,
        postRelevanceAfterToggled
      );
    }
    return comment;
  });
  return updatedCommentsInFeedModal;
}

export function updateCommentRelevanceAndRelevanceButton(
  comment,
  postRelevanceAfterToggled
){
  comment.postRelevance = postRelevanceAfterToggled;
  if (postRelevanceAfterToggled === false) {
    comment.relevance = false;
  } 
  else {
    if (comment.markedAsSpamByFilter === false) {
      comment.relevance = true;
    }
    else {
      comment.relevance = false;
    }
  }
  return comment;
}

export function updatePostCounts(
  feed,
  postCounts
) {
  feed = updatePostRelevantCommentCount(
    feed,
    postCounts
  );
  feed = updatePostSentimentCounts(
    feed,
    postCounts
  );
  feed = updatePostEmotionCounts(
    feed,
    postCounts
  );
  if (IS_SARCASM_ENABLED) {
    feed = updatePostSarcasticCommentCount(
      feed,
      postCounts
    );
  }
  return feed;
}

export function updatePostRelevantCommentCount(
  feed,
  postCounts
) {
  feed.relevantCommentCount = postCounts[TOTAL]
  return feed;
}

export function updatePostSentimentCounts(
  feed,
  postCounts
) {
  const newSentimentCounts = [...feed.sentiment]
  for (const sentiment of newSentimentCounts) {
    if (sentiment[CATEGORY_KEY] === POSITIVE) {
      sentiment[TOTAL] = postCounts[POSITIVE]
    } else if (sentiment[CATEGORY_KEY] === NEGATIVE) {
      sentiment[TOTAL] = postCounts[NEGATIVE]
    } else {
      sentiment[TOTAL] = postCounts[NEUTRAL]
    }
  }
  return feed;
}

export function updatePostEmotionCounts(
  feed,
  postCounts
) {
  const newEmotionCounts = {...feed.emotionCounts}
  newEmotionCounts[ANGER] = postCounts[ANGER]
  newEmotionCounts[FEAR] = postCounts[FEAR]
  newEmotionCounts[JOY] = postCounts[JOY]
  newEmotionCounts[SADNESS] = postCounts[SADNESS]
  feed.emotionCounts = newEmotionCounts;
  return feed;
}

export function updatePostSarcasticCommentCount(
  feed,
  postCounts
) {
  feed.sarcasticCommentCount = postCounts[SARCASTIC_KEY]
  return feed;
}

export function updateFeedModalFilteredCommentCounts(
  filteredCommentCounts,
  feedModalTabCounts
){
  if (filteredCommentCounts){
    filteredCommentCounts[ALL]      = feedModalTabCounts[TOTAL]
    filteredCommentCounts[ANGER]    = feedModalTabCounts[ANGER]
    filteredCommentCounts[FEAR]     = feedModalTabCounts[FEAR]
    filteredCommentCounts[JOY]      = feedModalTabCounts[JOY]
    filteredCommentCounts[SADNESS]  = feedModalTabCounts[SADNESS]
    filteredCommentCounts[POSITIVE] = feedModalTabCounts[POSITIVE]
    filteredCommentCounts[NEGATIVE] = feedModalTabCounts[NEGATIVE]
    filteredCommentCounts[NEUTRAL]  = feedModalTabCounts[NEUTRAL]
  }
  return filteredCommentCounts;
}



// WEBPACK FOOTER //
// ./src/features/home/redux/updateFeedsRelevant.js